/** @flow */
import { createAction } from "@actionCreator";

export type Action<A, T> = {
  type: A,
  payload: T,
};

export type ActionCreator<A, T> = (payload: T) => Action<A, T>;

export function actionCreatorsFactory<A: string, K: string, T: { [key: A]: K }>(
  actions: T,
): $ObjMap<T, (a: K) => ActionCreator<K, *>> {
  return Object.keys(actions).reduce((acc: { [A]: Function }, action: A) => {
    const actionName = action[0].toLowerCase() + action.slice(1);
    return Object.assign(acc, {
      [actionName]: createAction(actions[action]), // Must be deprecated I think.
      [action]: createAction(actions[action]), // Because it's impossible to make correct typings and to check that there's real action with some name
    });
  }, {});
}
